import ScrollReveal from '@/components/ScrollReveal';
import BeatsGrid from '@/components/BeatsGrid';
import { useLanguage } from '@/lib/i18n';

export default function Beats() {
  const { t } = useLanguage();

  return (
    <main id="main-content" className="pt-32 pb-24" data-testid="beats-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7F00FF]/60 mb-4">Beats</p>
          <h1 className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-4" data-testid="beats-page-title">
            Beats
          </h1>
          <p className="text-white/35 text-lg mb-16 max-w-xl" data-testid="beats-page-subtitle">
            {t('beats_subtitle')}
          </p>
        </ScrollReveal>
        <BeatsGrid />
      </div>
    </main>
  );
}
